<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Products and Services</h1>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="sharedService.changeRoute('home')"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <div
      class="action-bar mt-3 d-flex justify-content-between align-items-center bg-dark-subtle rounded-3"
    >
      <!-- Legend sits next to the Refresh Table button on the left side of
           the action bar. -->
      <div class="left-actions d-flex align-items-center gap-3">
        <button
          class="btn modern-btn blue-btn btn-sm"
          (click)="refreshTableDataClick()"
        >
          <i class="fa-solid fa-rotate me-2"></i>Refresh Table
        </button>
        <span class="legend">
          <i class="fa-solid fa-square" style="color: coral"></i>
          <span class="text-muted">Vendor</span>
          <span class="text-muted">Inventory</span>
        </span>
        <span class="legend">
          <i class="fa-solid fa-square" style="color: lightskyblue"></i>
          <span class="text-muted">Service</span>
        </span>
        <span class="legend">
          <i class="fa-solid fa-square" style="color: darkseagreen"></i>
          <span class="text-muted">Serial Item</span>
        </span>
      </div>

      <div class="right-actions d-flex gap-2">
        <div class="btn-group" dropdown container="body" placement="bottom right">
          <button
            dropdownToggle
            type="button"
            class="btn modern-btn grey-btn btn-sm dropdown-toggle"
          >
            Actions
          </button>
          <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-dark modern-dropdown shadow-lg dropdown-menu-end"
          >
            <li class="disabled">
              <a class="dropdown-item disabled">Services</a>
            </li>
            <li>
              <a class="dropdown-item" (click)="createNewService()"
                ><i class="fa-solid fa-plus me-2"></i>Create Service</a
              >
            </li>
            <li class="divider dropdown-divider"></li>
            <li class="disabled">
              <a class="dropdown-item disabled">Inventory</a>
            </li>
            <li>
              <a class="dropdown-item" (click)="createNewInventoryItem()"
                ><i class="fa-solid fa-box me-2"></i>Create Inventory Item</a
              >
            </li>
            <li class="divider dropdown-divider"></li>
            <li>
              <a
                class="dropdown-item"
                (click)="downloadProductServiceTemplate()"
                ><i class="fa-solid fa-download me-2"></i>Download Template</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                (click)="sharedService.openFilePicker('ProductService')"
                ><i class="fa-solid fa-file-import me-2"></i>Import From File</a
              >
            </li>
            @if (!show_inactive_items) {
              <li>
                <a
                  class="dropdown-item"
                  (click)="openImportVendorInventoryModalClick()"
                  ><i class="fa-solid fa-cloud-download me-2"></i>Download Live
                  Inventory</a
                >
              </li>
              <li>
                <a class="dropdown-item" (click)="showInactiveItemsClick()"
                  ><i class="fa-solid fa-eye me-2"></i>Include Inactive Items</a
                >
              </li>
            }
            @if (show_inactive_items) {
              <li>
                <a class="dropdown-item" (click)="removeInactiveItemsClick()"
                  ><i class="fa-solid fa-eye-slash me-2"></i>Remove Inactive
                  Items</a
                >
              </li>
            }
            <li class="divider dropdown-divider"></li>
            <li>
              <a
                class="dropdown-item"
                (click)="saveCurrentTablePreferencesClick()"
                ><i class="fa-solid fa-floppy-disk me-2"></i>Save Table
                Settings</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <ag-grid-angular
      #grid
      id="dispo_list"
      class="modern-grid flex-grow-1"
      style="width: 100%; height: 100%"
      
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="products_services_filtered"
      [preventDefaultOnContextMenu]="true"
      (gridReady)="onGridReady($event)"
      (cellContextMenu)="onCellContextMenu($event)"
      [animateRows]="true"
      [components]="components"
      [enableBrowserTooltips]="true"
      [pagination]="true"
      [paginationPageSize]="sharedService.default_pagination_page_size"
      [paginationPageSizeSelector]="[20, 50, 100, 500]"
      (filterChanged)="storeCurrentSessionFilters()"
      (columnPinned)="storeCurrentSessionColumnConfig()"
      (columnResized)="storeCurrentSessionColumnConfig()"
      (columnMoved)="storeCurrentSessionColumnConfig()"
      (sortChanged)="storeCurrentSessionColumnConfig()"
    ></ag-grid-angular>
    <!--[statusBar]="statusBar" need the enterprise version for this feature-->
  </div>
</div>

<!-- Added for the right click "Copy" function -->
@if ((menuState$ | async)?.showMenu) {
  <div
    class="custom-context-menu"
    [style.top.px]="(menuState$ | async)?.menuTop"
    [style.left.px]="(menuState$ | async)?.menuLeft"
    (click)="copyCellValue()"
    (mouseenter)="onMenuMouseEnter()"
    (mouseleave)="onMenuMouseLeave()"
  >
    <i class="fa-solid fa-copy me-2"></i> Copy
  </div>
}

<!-- Picture Lightbox -->
@if (isLightboxOpen) {
  <div class="lightbox-overlay" (click)="toggleLightbox(false)">
    <button class="close-lightbox" (click)="toggleLightbox(false)">
      <i class="fa-solid fa-xmark"></i>
    </button>

    @if (isThumbnailLoading) {
      <div class="d-flex flex-column align-items-center text-white" (click)="$event.stopPropagation()">
        <i class="fa-solid fa-circle-notch fa-spin mb-3" style="font-size: 3rem; color: #00a8ff;"></i>
        <span style="font-size: 1.2rem; font-weight: 500;">Fetching Image...</span>
      </div>
    } @else if (itemThumbnailUrls.length > 0) {
      @if (itemThumbnailUrls.length > 1) {
        <button class="lightbox-nav prev" (click)="prevImage($event)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <button class="lightbox-nav next" (click)="nextImage($event)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      }

      <div class="lightbox-content" (click)="$event.stopPropagation()">
        <img [src]="itemThumbnailUrls[currentImageIndex]" alt="Product Image" />

        @if (itemThumbnailUrls.length > 1) {
          <div class="carousel-count" style="bottom: -30px; top: auto; right: 50%; transform: translateX(50%);">
            {{ currentImageIndex + 1 }} / {{ itemThumbnailUrls.length }}
          </div>
        }
      </div>
    }
  </div>
}

